import { Component } from "react";
import * as React from "react";
import { Dropdown, IDropdownOption } from "office-ui-fabric-react";
import ApiService from "./ApiService";
import H from "history";
import { parseQueryString } from "../utils/Utils";
import moment from 'moment';

interface AcademicYearPickerProps {
    history: H.History;
    onSelectedKeyChange?: (academicYear: number) => void;
    disabled?: boolean;
}

interface AcademicYearPickerState {
    selectedAcademicYear: number;
}

export default class AcademicYearPicker extends Component<AcademicYearPickerProps, AcademicYearPickerState>
{
    public static startDateForAcademicYear = (academicYear: number) : moment.Moment => moment({ year: academicYear, month: 7, day: 1 });
    public static endDateForAcademicYear = (academicYear: number): moment.Moment => moment({ year: academicYear + 1, month: 6, day: 31 });

    public static defaultOptionKey: number = moment() < AcademicYearPicker.startDateForAcademicYear(moment().year()) ? moment().year() - 1 : moment().year();

    private static options: IDropdownOption[] = [
        {
            text: "2026-2027",
            key: 2026
        },
        {
            text: "2025-2026",
            key: 2025
        },
        {
            text: "2024-2025",
            key: 2024
        },
        {
            text: "2023-2024",
            key: 2023
        }
    ];

    public static fromQueryStringOrDefault(queryString: string): number {
        const queryObj = parseQueryString(queryString);
        const academicYear = Number(queryObj["academicYear"]);

        var option = AcademicYearPicker.options.find(o => o.key === academicYear);

        if (option) {
            return Number(option.key);
        }
        else {
            return AcademicYearPicker.defaultOptionKey;
        }
    }

    constructor(props: Readonly<AcademicYearPickerProps>) {
        super(props);

        const selectedAcademicYear = AcademicYearPicker.fromQueryStringOrDefault(props.history.location.search);

        this.state = {
            selectedAcademicYear
        };

        if (this.props.onSelectedKeyChange) {
            this.props.onSelectedKeyChange(this.state.selectedAcademicYear);
        }
    }

    componentDidUpdate(prevProps: Readonly<AcademicYearPickerProps>, prevState: Readonly<AcademicYearPickerState>, snapshot?: any): void {
        if (this.state.selectedAcademicYear !== prevState.selectedAcademicYear) {
            var queryObject = parseQueryString(this.props.history.location.search);

            queryObject["academicYear"] = String(this.state.selectedAcademicYear);

            const queryString = ApiService.buildQueryString(queryObject);

            this.props.history.replace({ search: queryString });

            if (this.props.onSelectedKeyChange) {
                this.props.onSelectedKeyChange(this.state.selectedAcademicYear);
            }
        }
    }

    public render() {
        return (
            <div className={"analytics-control-bar__academic-year-picker"}>
                <Dropdown
                    disabled={this.props.disabled}
                    label={"Academic Year"}
                    selectedKey={this.state.selectedAcademicYear}
                    options={AcademicYearPicker.options}
                    onChange={(event, option: any) => {
                        this.setState({
                            selectedAcademicYear: option.key,
                        });
                    }}
                />
            </div>
        );
    }
}